import { render } from "./DroppingPlace.vue?vue&type=template&id=030db4c9&scoped=true"
import script from "./DroppingPlace.vue?vue&type=script&lang=js"
export * from "./DroppingPlace.vue?vue&type=script&lang=js"

import "./DroppingPlace.vue?vue&type=style&index=0&id=030db4c9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030db4c9"]])

export default __exports__